// KWANKGM04330_近代化資金案件詳細（マイページ）画面のフッター部
import React, { memo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import {
  mp_flg as mp_flg_value,
  ma_flg as ma_flg_value,
  status_code_list,
  mypage_url,
} from '../Const';
import RowCenterButton from '../molecules/RowCenterButton';
import DefaultButton from '../molecules/DefaultButton';
import Popup from '../molecules/Popup';
import MypageReturn from '../molecules/MypageReturn';

interface Props {
  reception_cd: string;
  reception_id: number;
  status_code: number;
  mp_flg: number; // 借入申込希望書兼経営改善資金計画書フラグ
  ma_flg: number; // 代化資金借入申込書フラグ
  handleDecline: () => void | boolean; //『辞退する』のモジュール
  handleExecution: () => void | boolean; //『申込内容を変更する』のモジュール
}

const FooterModernizationFundButton: React.FC<Props> = ({
  reception_cd,
  reception_id,
  status_code,
  mp_flg,
  ma_flg,
  handleDecline,
  handleExecution,
}) => {
  const [modal_decline_open, setModalDeclineOpen] = useState(false);
  const [modal_change_application_open, setModalChangeApplicationOpen] = useState(false);
  const history = useHistory();

  /**
   * それぞれの条件にて、表示させるボタンを切り替える
   *
   * 連帯債務者等の不同意の場合・・・「辞退する」「申込内容を変更する」「マイページへ戻る」ボタンを表示
   * 借入申込保証人確認中、借入申込連携待ちの場合・・・「辞退する」「マイページへ戻る」を表示
   * それ以外の場合・・・「マイページへ戻る」を表示
   */
  const outputButton = () => {
    // 連帯債務者等の不同意の場合
    if (status_code === status_code_list.borrowing_application_disagreement) {
      return (
        <div className="mt-5">
          <Row className="flex-lg-row flex-md-reverse flex-sm-column-reverse flex-column-reverse">
            {outputDeclineButton()}
            {outputChangeButton()}
          </Row>
          <MypageReturn is_staff={false} />
        </div>
      );
    } else if (
      status_code === status_code_list.borrowing_application_check ||
      status_code === status_code_list.borrowing_application_waiting_mdn
    ) {
      return (
        <div className="mt-5 mb-5">
          <Row className="flex-lg-row row-cols-2 flex-md-reverse flex-sm-column-reverse flex-column-reverse">
            {outputMyPageRetrunButton()}
            <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-danger">
              <div className="text-right sp-button-center">
                <a className="btn btn-xl btn-danger" onClick={handleClickOpenDecline}>
                  辞退する
                </a>
              </div>
            </Col>
          </Row>
        </div>
      );
    } else {
      return <MypageReturn is_staff={false} />;
    }
  };

  // 変更中 または 借入申込保証人不同意の場合に『辞退する』ボタンを出力する
  const outputDeclineButton = () => {
    return (
      <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-left-button-danger">
        <div className="text-left sp-button-center">
          <a className="btn btn-xl btn-danger" onClick={handleClickOpenDecline}>
            辞退する
          </a>
        </div>
      </Col>
    );
  };

  // 借入申込保証人不同意の場合に『申込内容を変更する』ボタンを出力する
  const outputChangeButton = () => {
    return (
      <Col xs={12} sm={12} md={12} lg={6} xl={6} className="row-right-button-small">
        <div className="text-right sp-button-center">
          <a
            className="btn btn-xl btn-main-color sp-btn-height ml-auto"
            onClick={handleClickOpenChangeApplication}
          >
            申込内容を変更する
          </a>
        </div>
      </Col>
    );
  };

  // 『マイページへ戻る』ボタンを出力する
  const outputMyPageRetrunButton = () => {
    return (
      <Col xl={6} lg={6} md={6} sm={6} xs={12} className="row-left-button-arrow">
        <div className="text-left">
          <a
            className="btn btn-xl btn-main-color sp-my-page-return"
            onClick={handleClickMyPageReturn}
          >
            マイページへ
            <br className="d-lg-none d-md-none" />
            戻る
          </a>
        </div>
      </Col>
    );
  };

  // 入力中・変更中の場合に『申込を続ける』ボタンを出力する
  const outputNextButton = () => {
    if (
      mp_flg === mp_flg_value.input ||
      ma_flg === ma_flg_value.input ||
      mp_flg === mp_flg_value.change ||
      ma_flg === ma_flg_value.change
    ) {
      return (
        <div className="mt-5">
          <RowCenterButton>
            <DefaultButton label="申込を続ける" strong={false} handleClick={handleClickNext} />
          </RowCenterButton>
        </div>
      );
    } else {
      <></>;
    }
  };

  // 「申込を続ける」をクリックした時のアクション
  const handleClickNext = () => {
    sessionStorage.setItem('modernization_funds_input_type_select_referer', location.href);
    // 近代化資金入力種別選択画面へ遷移する
    location.href = `${location.origin}${process.env.MIX_MOCK_URL}/modernization_funds/input_type_select/${reception_cd}/${reception_id}`;
  };

  // 「辞退する」をクリックした時のアクション
  const handleClickOpenDecline = () => {
    setModalDeclineOpen(true);
  };

  // 「申込内容を変更する」をクリックした時のアクション
  const handleClickOpenChangeApplication = () => {
    setModalChangeApplicationOpen(true);
  };

  // 辞退する確認モーダルの『辞退する』ボタンをクリックしたときのアクション
  const handleClickDecline = async () => {
    const result_decline = await handleDecline();
    // 正常終了か判定
    if (result_decline) {
      // 正常終了の場合、近代化資金借入申込完了画面に遷移する
      history.push(`/reception/${reception_cd}/${reception_id}/${status_code}/declined`);
    }
  };

  // 申込内容を変更する確認モーダルの『申込内容を変更する』ボタンをクリックしたときのアクション
  const handleClickChangeApplication = async () => {
    const result_change_application = await handleExecution();
    // 正常終了か判定
    if (result_change_application) {
      // 正常終了の場合、 近代化資金入力種別選択画面へ遷移する
      sessionStorage.setItem('modernization_funds_input_type_select_referer', location.href);
      location.href = `${location.origin}${process.env.MIX_MOCK_URL}/modernization_funds/input_type_select/${reception_cd}/${reception_id}`;
    }
  };

  // 「マイページへ戻る」をクリックしたときのアクション
  const handleClickMyPageReturn = () => {
    location.href = mypage_url;
  };

  return (
    <>
      {outputNextButton()}
      {outputButton()}
      <Popup
        title="借入申込の辞退確認"
        text="申込の辞退となりますが、よろしいですか？"
        first_button={{
          label: '辞退する',
          variant: 'danger',
          handleClick: () => {
            handleClickDecline();
            setModalDeclineOpen(false);
          },
        }}
        second_button={{
          label: '戻る',
          variant: 'outline-success',
          handleClick: () => {
            setModalDeclineOpen(false);
          },
        }}
        toggleClose={() => setModalDeclineOpen(false)}
        toggleShow={modal_decline_open}
      />
      <Popup
        title="申込内容の変更"
        text="申込内容を変更できる状態に戻します。よろしいですか？"
        first_button={{
          label: '申込内容を変更する',
          variant: 'success',
          handleClick: () => {
            handleClickChangeApplication();
            setModalChangeApplicationOpen(false);
          },
        }}
        second_button={{
          label: '戻る',
          variant: 'outline-success',
          handleClick: () => {
            setModalChangeApplicationOpen(false);
          },
        }}
        toggleClose={() => setModalChangeApplicationOpen(false)}
        toggleShow={modal_change_application_open}
      />
    </>
  );
};

export default memo(FooterModernizationFundButton);
